export default __webpack_public_path__ + "static/media/1774.f321b367.png";